import { useQuery } from '@tanstack/react-query';
import { githubService } from '../services/githubService';

export const githubKeys = {
    all: ['github'] as const,
    repositories: () => [...githubKeys.all, 'repositories'] as const,
    branches: (repoName: string) => [...githubKeys.all, 'branches', repoName] as const,
    contents: (repoName: string, path: string, ref: string) => [...githubKeys.all, 'contents', repoName, path, ref] as const,
    file: (repoName: string, path: string, ref: string) => [...githubKeys.all, 'file', repoName, path, ref] as const,
};

export function useGithubRepositories() {
    return useQuery({
        queryKey: githubKeys.repositories(),
        queryFn: () => githubService.getRepositories(),
        // Only fetch if token exists (handled by apiClient usually, but we can be explicit if needed)
        staleTime: 5 * 60 * 1000,
    });
}

export function useGithubBranches(repoName: string | null) {
    return useQuery({
        queryKey: githubKeys.branches(repoName || ''),
        queryFn: () => githubService.getBranches(repoName!),
        enabled: !!repoName,
    });
}

export function useGithubContents(repoName: string | null, path: string = '', ref: string = 'main') {
    return useQuery({
        queryKey: githubKeys.contents(repoName || '', path, ref),
        queryFn: () => githubService.getContents(repoName!, path, ref),
        enabled: !!repoName,
        staleTime: 10 * 60 * 1000, // Mantener en memoria por 10 minutos
        gcTime: 30 * 60 * 1000,    // Guardar en caché 30 minutos
    });
}

export function useGithubFile(repoName: string, path: string, ref: string = 'main') {
    return useQuery({
        queryKey: githubKeys.file(repoName, path, ref),
        queryFn: () => githubService.getFile(repoName, path, ref),
        enabled: !!repoName && !!path,
    });
}
